module.exports = __webpack_public_path__ + "static/media/senchatea.9492e47d.jpg";